import { useRootOutcomesStore } from "./root-outcomes.store";
import { useRootOutcome } from "./root-outcome.hook";

export const useRootOutcomes = () => {
  const rootOutcomes = useRootOutcomesStore((state) => state.rootOutcomes);
  const clearRootOutcomes = useRootOutcomesStore(
    (state) => state.clearRootOutcomes
  );

  const topOutcomeId = Object.keys(rootOutcomes)?.[0] || "";

  const {
    rootOutcome: topRootOutcome,
    removeRootOutcome: removeTopRootOutcome,
  } = useRootOutcome(topOutcomeId);

  const removeRootOutcomes = () => clearRootOutcomes();

  return {
    rootOutcomes,
    topRootOutcome,
    removeRootOutcomes,
    removeTopRootOutcome,
  };
};
